/* eslint-disable react/jsx-props-no-spreading */
import Pluralize from 'typescript-pluralize';
import { FC } from 'react';
import Slider from 'react-slick';
import Card from 'components/modules/Card';
import { nanoid } from 'nanoid';
import { IFeaturedData } from 'provider/FeaturedProvider/FeaturedProvider.interface';
import { ICarouselItems } from '../Carousel.interface';

const settings = {
  dots: true,
  infinite: false,
  arrows: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  swipe: true,
  initialSlide: 0,
  appendDots: (dots: number) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '10px 0',
        bottom: -40,
      }}
    >
      <ul className="mb-0"> {dots} </ul>
    </div>
  ),
  customPaging: (i: number) => (
    <div className="flex justify-center items-center h-[7px] w-[7px] bg-[#D3D3D3] rounded-full" />
  ),
  responsive: [
    {
      breakpoint: 1536,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 1920,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        dots: true,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 0,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        dots: true,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        dots: true,
      },
    },
  ],
};

export const CardCarousel: FC<ICarouselItems> = ({ items }) => {
  const items_sort_key = [
    'resources',
    'action_lists',
    'videos',
    'articles',
    'tips',
    'lessons',
    'audios',
    'questions',
    'products',
    'journals',
    'podcasts',
  ];

  const sorted_items = items
    ?.filter(
      (i) => !['journals', 'galleries', 'messages'].includes(i.content_type),
    )
    ?.sort(
      (a: IFeaturedData, b: IFeaturedData) =>
        items_sort_key.indexOf(a.content_type) -
        items_sort_key.indexOf(b.content_type),
    );

  return (
    <div className="-mx-2 xl:-mx-2">
      <Slider {...settings}>
        {sorted_items?.map((item: IFeaturedData) => (
          <Card
            key={`card-${nanoid()}`}
            type={Pluralize.singular(item.content_type)}
            header={Pluralize.singular(item.content_type)}
            title={item.title}
            image={item.image_url}
            alt="Featured Card"
            description={item.description}
            author={item.author}
            id={item.id}
          />
        ))}
      </Slider>
    </div>
  );
};
